(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.DrawToolbar = (function(superClass) {
    extend(DrawToolbar, superClass);

    function DrawToolbar() {
      this.activate = bind(this.activate, this);
      this.disableCurrent = bind(this.disableCurrent, this);
      this._finalizeGeometry = bind(this._finalizeGeometry, this);
      this.handleDrawComplete = bind(this.handleDrawComplete, this);
      this._polySelected = bind(this._polySelected, this);
      this._deletePressed = bind(this._deletePressed, this);
      this._selectPressed = bind(this._selectPressed, this);
      this._undoPressed = bind(this._undoPressed, this);
      this._drawCircle = bind(this._drawCircle, this);
      this._drawRectangle = bind(this._drawRectangle, this);
      this._drawPolygon = bind(this._drawPolygon, this);
      this._anyButtonPressed = bind(this._anyButtonPressed, this);
      DrawToolbar.include(L.Mixin.Events);
      this.drawMode = ko.observable('add');
      this.currentTool = ko.observable();
      this.dontReenableDraw = false;
      this.lastClicked = ko.observable();
      this.prevClicked = ko.observable();
      this.orig_options = this.initShapeDefaults();
      this.drawnOptions = this.orig_options.shape;
      this.drawControlOptions = {
        draw: {
          polygon: {
            allowIntersection: false,
            shapeOptions: this.orig_options.shape
          },
          rectangle: {
            shapeOptions: this.orig_options.shape
          },
          circle: {
            shapeOptions: this.orig_options.shape,
            units: 'english'
          }
        }
      };
      this.events = new L.MassEvents();
    }

    DrawToolbar.prototype.init = function() {
      this.drawControl = new L.Control.MfDraw(this.drawControlOptions);
      if (this.drawnItems == null) {
        this.initDrawnItems();
      }
      App.map.addControl(this.drawControl);
      return this.initListeners();
    };

    DrawToolbar.prototype.initDrawnItems = function() {
      this.drawnItems = new L.FeatureGroup();
      App.map.addLayer(this.drawnItems);
      return this.undoStack = new L.GeomUndoStack(this.drawnItems);
    };

    DrawToolbar.prototype.initListeners = function() {
      var self;
      self = this;
      this.events.on([[this, ['delete:pre-delete', 'pre-add-feature']], [App.map, ['draw:point-begin-remove', 'draw:point-begin-edit']]], this.undoStack.push);
      App.map.on('draw:created', this.handleDrawComplete);
      this.drawControl.addCallback('*', this._anyButtonPressed);
      this.drawControl.addCallback('draw-poly-sub,draw-rect-sub,draw-circle-sub', this._subtractiveButtonPressed);
      this.drawControl.addCallback('draw-poly-add,draw-rect-add,draw-circle-add', this._additiveButtonPressed);
      this.drawControl.addCallback('draw-poly-add,draw-poly-sub', this._drawPolygon);
      this.drawControl.addCallback('draw-rect-add,draw-rect-sub', this._drawRectangle);
      this.drawControl.addCallback('draw-circle-add,draw-circle-sub', this._drawCircle);
      this.drawControl.addCallback('draw-undo', this._undoPressed);
      this.drawControl.addCallback('draw-select', this._selectPressed);
      return this.drawControl.addCallback('draw-delete', this._deletePressed);
    };

    DrawToolbar.prototype._anyButtonPressed = function(e, name) {
      if ((this.currentTool() != null) && (this.currentTool().disable != null)) {
        this.currentTool().disable();
      }
      if (name !== 'draw-undo') {
        this.undoStack.clearInvalidGeometryFromStack();
      }
      this.prevClicked(this.lastClicked());
      return this.lastClicked(name);
    };

    DrawToolbar.prototype._drawPolygon = function() {
      var handler, self;
      self = this;
      handler = new L.Draw.Polygon(App.map, this.drawControl.options.draw.polygon);
      this.currentTool({
        h: handler,
        killed: false,
        disable: function() {
          var ref;
          if (this.killed) {
            return;
          }
          this.killed = true;
          if (((ref = this.h._poly) != null ? typeof ref.getLatLngs === "function" ? ref.getLatLngs().length : void 0 : void 0) > 2) {
            self.dontReenableDraw = true;
            this.h._markers[0].fire('click');
            return self.dontReenableDraw = false;
          } else {
            return this.h.disable();
          }
        }
      });
      return handler.enable();
    };

    DrawToolbar.prototype._drawRectangle = function() {
      this.currentTool(new L.Draw.Rectangle(App.map, this.drawControl.options.draw.rectangle));
      return this.currentTool().enable();
    };

    DrawToolbar.prototype._drawCircle = function() {
      this.currentTool(new L.Draw.BetterCircle(App.map, this.drawControl.options.draw.circle));
      return this.currentTool().enable();
    };

    DrawToolbar.prototype._undoPressed = function() {
      this.undoStack.undo();
      if (this.prevClicked() === 'draw-select' && this.drawnItems.getLayers().length === 1) {
        this.drawControl.getButton('draw-select').trigger('click');
        return this._polySelected({
          layer: this.drawnItems.getLayers()[0]
        });
      }
    };

    DrawToolbar.prototype._selectPressed = function() {
      var self;
      self = this;
      this.drawnItems.on('click', this._polySelected);
      this.fire('select:no-poly');
      return this.currentTool({
        h: null,
        disable: function() {
          if ((this.h != null) && (this.h.disable != null)) {
            this.h.disable();
          }
          return self.drawnItems.off('click', this._polySelected);
        }
      });
    };

    DrawToolbar.prototype._deletePressed = function() {
      var cb, mm, tooltip;
      if (this.drawnItems.getLayers().length === 0) {
        this.drawControl.deselectBtn('draw-delete');
        return;
      }
      cb = (function(_this) {
        return function(e) {
          _this.fire('delete:pre-delete');
          _this.drawnItems.removeLayer(e.layer);
          _this.fire('delete:layer-deleted', e.layer);
          _this.currentTool().disable();
          return _this.drawControl.deselectBtn('draw-delete');
        };
      })(this);
      tooltip = new L.Tooltip(App.map);
      tooltip.updateContent({
        text: 'Click on an area to delete it'
      });
      mm = (function(_this) {
        return function(e) {
          return tooltip.updatePosition(e.latlng);
        };
      })(this);
      App.map.on('mousemove', mm);
      this.drawnItems.on('click', cb);
      this.fire('delete:delete');
      return this.currentTool({
        disable: (function(_this) {
          return function() {
            _this.drawnItems.off('click', cb);
            _this.fire('inactive');
            App.map.off('mousemove', mm);
            tooltip.dispose();
            return _this.currentTool(null);
          };
        })(this)
      });
    };

    DrawToolbar.prototype._polySelected = function(e) {
      var handler;
      handler = new L.Edit.PolyWithHoles(e.layer);
      handler.enable();
      this.fire('select:poly-selected');
      if ((this.currentTool().h != null) && (this.currentTool().h.disable != null)) {
        this.currentTool().h.disable();
      }
      this.currentTool().h = handler;
      handler.on('geometry-invalid', (function(_this) {
        return function() {
          return _this.drawnItems.isInvalid = true;
        };
      })(this));
      return handler.on('geometry-valid', (function(_this) {
        return function() {
          return _this.drawnItems.isInvalid = false;
        };
      })(this));
    };

    DrawToolbar.prototype.initShapeDefaults = function() {
      var editOpts, shapeOpts;
      shapeOpts = {
        fillColor: '#00FF00',
        color: '#00FF00',
        opacity: 0.75,
        weight: 2,
        fillOpacity: 0.2
      };
      editOpts = $.extend(shapeOpts, {
        fillOpacity: 0.1,
        guidelineDistance: 20
      });
      return {
        shape: shapeOpts,
        edit: editOpts
      };
    };

    DrawToolbar.prototype._combineGeometry = function(oldgeom, newgeom, operation) {
      var geom, newGeom, oldGeom;
      newGeom = L.GeoUtil.readToJSTS(newgeom);
      oldGeom = L.GeoUtil.readToJSTS(oldgeom);
      if (newGeom.geometry != null) {
        newGeom = newGeom.geometry;
      }
      if (oldGeom == null) {
        geom = newGeom;
      } else {
        geom = oldGeom[operation](newGeom);
      }
      return geom;
    };

    DrawToolbar.prototype.handleDrawComplete = function(e) {
      var geom, layer, operation, out, self, type;
      self = this;
      type = e.layerType;
      layer = e.layer;
      if (this.drawnItems == null) {
        this.initDrawnItems();
      }
      if (type === 'circle') {
        layer = new L.PolyCircle(layer.getLatLng(), layer.getRadius(), {
          nodes: 20
        });
        layer = layer.getPoly();
      }
      if (this.drawMode() === 'add') {
        operation = 'union';
      } else {
        operation = 'difference';
      }
      geom = L.GeoUtil.combine(this.drawnItems, layer, operation);
      out = this._finalizeGeometry(geom);
      this.fire('pre-add-feature');
      this.drawnItems.clearLayers();
      L.GeoUtil.unnestAdd(this.drawnItems, out);
      this._setStyles();
      this.fire('post-add-feature');
      if (!this.dontReenableDraw) {
        return this.drawControl.handleClick(this.lastClicked());
      }
    };

    DrawToolbar.prototype._setStyles = function(style) {
      if (style == null) {
        style = this.drawnOptions;
      }
      return this.drawnItems.eachLayer(function(l) {
        if (l.setStyle != null) {
          return l.setStyle(style);
        }
      });
    };

    DrawToolbar.prototype._finalizeGeometry = function(geom) {
      return L.GeoUtil.readFromJSTS(geom, this.drawnOptions);
    };

    DrawToolbar.prototype.getAreas = function(pusharray, start) {
      if (pusharray == null) {
        pusharray = [];
      }
      if (start == null) {
        start = this.drawnItems;
      }
      start.eachLayer((function(_this) {
        return function(layer) {
          if (layer instanceof L.FeatureGroup) {
            return _this.getAreas(pusharray, layer);
          } else {
            return pusharray.push(layer);
          }
        };
      })(this));
      return pusharray;
    };

    DrawToolbar.prototype.disableCurrent = function() {
      var ref;
      if ((ref = this.currentTool()) != null) {
        if (typeof ref.disable === "function") {
          ref.disable();
        }
      }
      return this.currentTool(null);
    };

    DrawToolbar.prototype.activate = function(name) {
      var btn;
      btn = this.drawControl.getButton(name);
      if (btn != null) {
        return this.drawControl.handleClick(name);
      }
    };

    DrawToolbar.prototype.destroy = function() {
      App.map.removeControl(this.drawControl);
      if ((this.currentTool() != null) && (this.currentTool().disable != null)) {
        this.currentTool().disable();
      }
      App.map.off('draw:created', this.handleDrawComplete);
      if (this.drawnItems != null) {
        return App.map.removeLayer(this.drawnItems);
      }
    };

    return DrawToolbar;

  })(L.Class);

}).call(this);
